import { render, staticRenderFns } from "./vendor-details-orders.vue?vue&type=template&id=146f0fa8&scoped=true"
import script from "./vendor-details-orders.vue?vue&type=script&lang=js"
export * from "./vendor-details-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146f0fa8",
  null
  
)

export default component.exports